/**************************************************
 * Nombre:       Dialogo_Ahorro_Editar
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Check, Delete} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import Formulario_Ahorro from "../Formularios/Formulario_Ahorro";
import {calcularCuotas} from "../../CodNegocio/Cuotas/calcularCuotas";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";
import {crearBolsillo} from "../../CodNegocio/Bolsillo/crearBolsillo";
import {obtenerTotalAhorrado} from "../../CodNegocio/Bolsillo/obtenerTotalAhorrado";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";

const Dialogo_Ahorro_Editar = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })
    const [calculos, setCalculos] = useState({})


    const subirDatos = async () => {

        await calcular()

        let entidad = await obtenerEntidad()
        let cerrar_ = entidad.cerrar
        delete entidad.cerrar
        iniciarCarga('Creando Bolsillo')

        let dox = await crearBolsillo({entidad: entidad, usuario: cData.usuario})

        if (dox.res) {

            terminar({aviso: 'Ahorro creado con exito'})
            //  cerrar_()

        } else {
            terminar({aviso: 'Algo inesperado paso, porfavor intentalo nuevamentes', variante: 'error'})
        }


    }

    const calcular = async () => {

        let entidad = await obtenerEntidad()
        let valorCuota = calcularCuotas({meta: entidad.valor, meses: entidad.numMeses, tasaMensual: 1})
        let valorAhorrado = valorCuota * entidad.numMeses
        let valorRendimientos = entidad.valor - valorAhorrado
        setCalculos({
            valorCuota: valorCuota,
            valorAhorrado: valorAhorrado,
            valorRendimientos: valorRendimientos,
            total: valorRendimientos + valorAhorrado
        })

    }

    const borrar = async () => {

        iniciarCarga('Procesando Solicitud...')
        let ahorros = await obtenerTotalAhorrado({idBolsillo: datos.id})

        if (ahorros > 100) {
            terminar({
                aviso: 'No se puede borrar este ahorro ya que tiene dinero, comuniquese con soporte',
                variante: 'error'
            })
        } else {
            await borrarDoc('bolsillos', datos.id)
            terminar({aviso: 'Bolsillo borrado'})
        }


    }

    useEffect(() => {
        setCalculos({})

        if (datos.id) {
            calcular().then()
        }

    }, []);


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Ahorro props={props}/>
            </Grid>

            <Grid container size={12} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    onClick={() => calcular()}
                    variant={'outlined'} fullWidth sx={{py: 1.3, lineHeight: 1.1}}>Calcular Mensualidad</Button>
            </Grid>

            {calculos.total &&

                <>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography>Montos Calculados</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontWeight: 800, fontSize: 20}}><span
                                    style={{fontWeight: 600}}>Ahorro Mensual: </span>{formatoMoneda(calculos.valorCuota)}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'space-between', mt: 2}}>
                                <Typography sx={{fontWeight: 600}}>Ahorro titular:</Typography>
                                <Typography sx={{fontWeight: 600}}>{formatoMoneda(calculos.valorAhorrado)}</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'space-between', mt: 0}}>
                                <Typography sx={{fontWeight: 600}}>Rendimientos:</Typography>
                                <Typography
                                    sx={{fontWeight: 600}}>{formatoMoneda(calculos.valorRendimientos)}</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'space-between', pt: 1, mt: 1, borderTop: 1}}>
                                <Typography sx={{fontWeight: 800, fontSize: 20}}>Monto a retirar:</Typography>
                                <Typography
                                    sx={{fontWeight: 800, fontSize: 20}}>{formatoMoneda(calculos.total)}</Typography>
                            </Grid>

                        </Grid>
                    </Grid>

                </>

            }

            {calculos.total &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                    <Button
                        onClick={() => subirDatos()}
                        startIcon={<Check/>}
                    >Editar Ahorro</Button>
                </Grid>
            }


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', marginTop: 3}}>
                <Button
                    variant={'text'}
                    color={'success'}
                    onClick={() => borrar()}
                    startIcon={<Delete/>}
                >Borrar Bolsillo</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Ahorro_Editar